import React, { ReactElement } from "react";
import * as Middleware from "@middlewares/index";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const HowToUseWithAuth = (): ReactElement => {
  SwiperCore.use([Navigation, Pagination]);

  return (
    <div className="modal-wrap how-to-use">
      <button
        className="modal__close"
        onClick={() => {
          Middleware.Ui.Modal.close();
        }}
      />
      <div className="modal modal--content modal--use-with-auth">
        <div className="modal__header">
          <div className="modal__title">Как пользоваться?</div>
        </div>
        <div className="how-to-use__slider-wrapper">
          <Swiper
            slidesPerView={1}
            spaceBetween={32}
            loop={false}
            pagination={{
              el: ".swiper-pagination",
              clickable: true,
              type: "bullets",
            }}
            navigation={{
              prevEl: ".how-to-use__slider-prev",
              nextEl: ".how-to-use__slider-next",
            }}
          >
            <SwiperSlide>
              <div className="how-to-use__slide">
                <div className="how-to-use__body">
                  <div className="how-to-use__slide-title">
                    Находите участника
                  </div>
                  <div className="how-to-use__slide-desc">
                    Выберите, кого из участников вы ищете — <b>компанию</b> или{" "}
                    <b>представителя</b>. Воспользуйтесь поисковой строкой или
                    используйте фильтры для поиска.
                  </div>
                </div>
                <picture className="how-to-use__slide-img">
                  <source
                    srcSet={require("@public/images/modals/netw-find-member-mobile.png")}
                    media="(max-width: 767px)"
                  />
                  <source
                    srcSet={require("@public/images/modals/netw-find-member-tablet.png")}
                    media="(max-width: 1279px)"
                  />
                  <source
                    srcSet={require("@public/images/modals/netw-find-member-desktop.png")}
                  />
                  <img
                    src={require("@public/images/modals/netw-find-member-mobile.png")}
                    alt="Находите участника"
                  />
                </picture>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="how-to-use__slide">
                <div className="how-to-use__body">
                  <div className="how-to-use__slide-title">
                    Выбирайте компанию
                  </div>
                  <div className="how-to-use__slide-desc">
                    Выберите интересующую вас компанию и кликните на нее, чтобы
                    прочитать больше о ее деятельности.
                  </div>
                </div>
                <picture className="how-to-use__slide-img">
                  <source
                    srcSet={require("@public/images/modals/netw-choose-company-mobile.png")}
                    media="(max-width: 767px)"
                  />
                  <source
                    srcSet={require("@public/images/modals/netw-choose-company-tablet.png")}
                    media="(max-width: 1279px)"
                  />
                  <source
                    srcSet={require("@public/images/modals/netw-choose-company-desktop.png")}
                  />
                  <img
                    src={require("@public/images/modals/netw-choose-company-mobile.png")}
                    alt="Выбирайте компанию"
                  />
                </picture>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="how-to-use__slide">
                <div className="how-to-use__body">
                  <div className="how-to-use__slide-title">Начните общение</div>
                  <div className="how-to-use__slide-desc">
                    Выберите представителя компании, с которым хотите установить
                    контакт. Обменяйтесь контактами — онлайн-визитками.
                  </div>
                </div>
                <picture className="how-to-use__slide-img">
                  <source
                    srcSet={require("@public/images/modals/netw-start-conversation-mobile.png")}
                    media="(max-width: 767px)"
                  />
                  <source
                    srcSet={require("@public/images/modals/netw-start-conversation-tablet.png")}
                    media="(max-width: 1279px)"
                  />
                  <source
                    srcSet={require("@public/images/modals/netw-start-conversation-desktop.png")}
                  />
                  <img
                    src={require("@public/images/modals/netw-start-conversation-mobile.png")}
                    alt="Начните общение"
                  />
                </picture>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div className="swiper-pagination how-to-use__slider-pagination" />
      <div className="how-to-use__slider-nav how-to-use__slider-prev" />
      <div className="how-to-use__slider-nav how-to-use__slider-next" />
    </div>
  );
};

export default HowToUseWithAuth;
